"use strict";
import regression from 'regression';

var regressao = function(data) {
  var tipoDeAjusteCurva = 'linear' //['linear', 'polynomial']
  var opcaoAjusteCurvaLinear = 'pontual' // 'faixa', 'pontual'



  var formataNumeroNAlg = function(num, n) {
    n = n || 1
    return parseFloat((num).toExponential(n))
  }

  var termosEquacaoArred = function(arr) {
    if(!arr) return
    return [
      parseFloat((arr[0]).toExponential(2)),
      parseFloat((arr[1]).toExponential(2))
    ]
  }

  var formataEquacao = function(arr) {
    const termos = termosEquacaoArred(arr)

    var parametroFormula
    if (Math.abs(termos[1]) < 1e-12) {
      parametroFormula =  termos[0].toExponential(2) + '*x'
    } else if (Math.abs(termos[0]) === 0) {
      parametroFormula = termos[1].toExponential(2)
    } else {
      const somaSubStr = termos[1] >= 0 ? '*x + ' : '*x - '
      parametroFormula = (arr[0]).toExponential(2) + 
      somaSubStr + 
      Math.abs(termos[1]).toExponential(2)
    }
    return parametroFormula
  }

  var pegaTextoRegressao = function(equacaoArr) {
    var obj = {}
    var formulaTemplate = 'se( x <= {0} ;{1} ;{2} )'
    var formula = formulaTemplate
    var nEq = equacaoArr.length
    //const br = ''
    const br = '\n' // descomente para quebar linhas nas formulas

    if (nEq === 1) {
      obj.formula = formataEquacao(equacaoArr[0].regressaoArr)
    } else {
      
      for (var i = 0; i < equacaoArr.length; i++) {
        formula = formula
          .replace('{0}', equacaoArr[i].termoADireita)
          .replace('{1}', ''+br+' '+formataEquacao(equacaoArr[i].regressaoArr))
        ;
        // Se for ultimo item, fecha formula
        if (i === equacaoArr.length-1) {
          formula = formula.replace('{2}', ''+br+formataEquacao(equacaoArr[i].regressaoArr))
        }
        // Completa argumentos `else`
        if (i < equacaoArr.length-2) {
          formula = formula.replace('{2}', ''+br+formulaTemplate)
        }
      }
      obj.formula = formula.replace(/\./g, ',')
      
    }
    
    obj.termos = equacaoArr.map((eqObj, i) => {
      var condicao
      if ((nEq-1) === i) {
        condicao = i === 0 ? null : ';'
      } else {
        condicao = 'se(x <= ' + eqObj.termoADireita + ' ; '
      }
      return {
        'condicao': condicao,
        'regressao': formataEquacao(eqObj.regressaoArr)
      }
    })
    return obj
  }

  var obj = {}
  if (opcaoAjusteCurvaLinear === 'faixa') {
    // Esta condicao não está disponivel inicialmente,
    // apenas a pontual
    let regressaoArr = regression
      .equation
    ;
    obj.equacaoArr = [{termoADireita: null, regressaoArr: regressaoArr}]
  } else {
    // Análise da faixa
    let paresArr = [] // [x,y], [x,y],...,[x,y]
    
    if (data.length > 1) {
      for (var i = 1; i < data.length; i++) {
        paresArr.push([data[i-1], data[i]])
      }
    } else {
      // Se a serie tiver apenas um ponto
      // adiciona um zero no inicio para realizar 
      // a regressão corretamente
      paresArr.push([[0,0], data[0]])
    }

    obj.equacaoArr = paresArr.map((parArr, parIndex) => {
      var regressaoPontoObj = {}
      
      let parArrArred = [
        [parArr[0][0], formataNumeroNAlg(parArr[0][1])],
        [parArr[1][0], formataNumeroNAlg(parArr[1][1])]
      ]
      
      let regressaoPar = regression[tipoDeAjusteCurva](parArrArred, {precision: 16})
        .equation
      ;
      
      let valorSupDoInstrumento = parArr[1][0].toString()
      regressaoPontoObj.termoADireita = valorSupDoInstrumento
      regressaoPontoObj.regressaoArr = regressaoPar
      return regressaoPontoObj
    })
    obj.termosRegressao = pegaTextoRegressao(obj.equacaoArr)
  }
  return obj
}


export default regressao